module.exports = __webpack_public_path__ + "img/check.ebb6e736.svg";